<template>
  <div>
    <template v-if="$store.state.dingding === 'dingtalk' && isSpecialData.projectStr " />
    <div
      v-else
      class="layout"
    >
      <!-- header 头部 -->
      <org-header />
      <!-- 通栏提示 -->
      <full-tips />
      <!-- 中间部分 -->
      <div
        class="clearfix"
        :class="{section: $route.name!== 'OrgIndex' }"
      >
        <router-view />
      </div>
      <!-- footer 尾部 -->
      <div class="footer">
        Copyright © 2008～2021 {{ $t('message["1089"]') }}
      </div>
    </div>
  </div>
</template>
<script>
import OrgHeader from './OrgHeader'
import FullTips from './FullTips'
import { getDingding } from '@/services/index'
import { isMobile } from '@/lib/device'
import { mapActions, mapMutations } from 'vuex'
export default {
  components: {
    OrgHeader,
    FullTips
  },
  data () {
    return {
      isReady: false,
      isSpecialData: {}
    }
  },
  computed: {
  },
  created () {
    // 链接列有参数referrer时
    if (this.$store.state.dingding === 'dingtalk') {
      this.getData()
    }
  },
  methods: {
    ...mapActions(['setSocketMessage', 'permissionMenu']),
    ...mapMutations(['setRoleDefault']),
    async filterPro (e) {
      let ishidden = e.target.checked ? 1 : 0
      // this.setIsHidden(ishidden)
      const chain = await this.fetchOrgDatas()
      chain.params({ ishidden: ishidden })
        .fetch()
    },
    async getData () {
      const chain = await getDingding()
      chain.onSuccess(async (raw) => {
        this.isSpecialData = raw
        this.isReady = true
        if (raw.projectStr) {
          await this.specialTo(raw)
        }
      })
        .fetch()
    },
    async specialTo (datas) {
      this.$store.commit('setPid', datas.projectStr)
      let to = ''
      let linkName = ''
      let routerName = 'InqueryList'
      switch (datas.system_role * 1) {
        case 1: // 负责人, 观察员
          linkName = { type: 'inquiry-manager-all', from: 'all' }
          break
        case 2: // 开发
          linkName = { type: 'inquiry-dev', from: 'my' }
          break
        case 3: // 接待
          linkName = { type: 'inquiry-add', from: 'my' }
          break
        default: // 销售
          linkName = { type: 'inquiry-followup', from: 'my' }
      }
      const pid = datas.projectStr // this.$store.state.pid
      if (!isMobile) {
        if (datas.system_role * 1 === 0) {
          this.setRoleDefault(true)
          const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
          chain.params({ cid: datas.cid * 1, projectid: datas.projectid * 1 })
            .onSuccess(res => {
              for (let key in res) {
                if (key === 'inquiry-mine' && res[key]['state']) {
                  let item = res[key]
                  if ('child' in item) {
                    for (let cKey in item['child']) {
                      linkName = { type: cKey, from: 'my' }
                      break
                    }
                  }
                  break
                }
                if (key === 'inquiry-mine' && !res[key]['state']) {
                  // console.log('查重： inquiry-check-repeat')
                  routerName = 'InqueryRepeat'
                  linkName = {}
                  break
                }
              }
            }).onComplete((raw) => {
              // console.log(linkName)
              to = {
                name: routerName,
                params: {
                  pid
                },
                query: linkName
              }
              this.$router.push(to)
            }).fetch()
        } else {
          to = {
            name: routerName,
            params: {
              pid
            },
            query: linkName
          }
          this.$router.push(to)
        }
      } else {
        to = {
          name: 'ProjectIndex',
          params: {
            pid
          }
        }
        this.$router.push(to)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
@media screen and (max-width: 1200px) {
  .layout .section .org-container {
      overflow-x: auto;
      // overflow-y: hidden;
  }
  /* .org-container .org-main {
    width: 1278px;
  } */
}
</style>
<style lang="scss" scoped>
.layout {
  overflow: hidden;
  background-color: #f5f6f7;
  .section {
    position: relative;
    overflow: hidden;
    max-width: 1280px;
    margin: 16px auto 0;
    background-color: #fff;
    border: solid 1px $gray4;
    border-radius: 4px;
    min-height: calc(100vh - 56px - 16px - 44px);
    // min-height: 784px;
  }

  .footer {
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}
</style>
